import { Directive } from '@angular/core';

/** The floating label for a `mat-form-field`. */
@Directive({
  selector: 'app-mat-label',
})
export class MatLabelDirective {}
